import type { TourDefinition } from "@/types/tour";

export const foundershubAdminOnboarding: TourDefinition = {
  id: "foundershub-admin-onboarding",
  context: "foundershub-admin",
  version: 1,
  steps: [
    {
      popover: {
        title: "Welcome to FoundersHub",
        description:
          "This is the admin view for managing entrepreneur applications, profiles, and project matching.",
      },
    },
    {
      element: '[data-tour-id="fh-sidebar-dashboard"]',
      popover: {
        title: "Dashboard",
        description:
          "Get an overview of application metrics, pipeline status, and recent activity.",
      },
    },
    {
      element: '[data-tour-id="fh-sidebar-applications"]',
      popover: {
        title: "Applications",
        description:
          "Review incoming entrepreneur applications. Approve, reject, or request more information.",
      },
    },
    {
      element: '[data-tour-id="fh-sidebar-entrepreneurs"]',
      popover: {
        title: "Entrepreneurs",
        description:
          "Browse all approved entrepreneurs. View their profiles, scores, and matched opportunities.",
      },
    },
    {
      element: '[data-tour-id="fh-sidebar-projects"]',
      popover: {
        title: "Projects",
        description:
          "Manage projects available for entrepreneur matching and track assignment status.",
      },
    },
    {
      element: '[data-tour-id="topnav-tour-button"]',
      popover: {
        title: "Replay Tour",
        description:
          "You can replay this tour anytime by clicking this button.",
      },
    },
  ],
};
